module.exports = __webpack_public_path__ + "img/success.e5f630ef.png";